var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.259,
    height: 14.792,
    viewBox: "0 0 10.259 14.792",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "gps_3",
    "data-name": "gps 3",
    d: "M359.759,4340.639c0,4.035-4.34,8.777-4.525,8.978a.815.815,0,0,1-1.209,0c-.184-.2-4.526-4.943-4.526-8.978a5.145,5.145,0,1,1,10.259,0Zm-5.129,2.773a2.782,2.782,0,1,0-2.564-2.773A2.673,2.673,0,0,0,354.63,4343.412Z",
    transform: "translate(-349.5 -4335.093)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocation);
export default __webpack_public_path__ + "static/media/icon-location.1722fe90cb0c582bfb6b44bed61cba8e.svg";
export { ForwardRef as ReactComponent };